import { Button, Stack, Typography } from '@mui/material';
import { BaseDialog } from '@/components/shared/base-dialog';
import { useNotification } from '@/context/notification';
import { useRemoveEmployee } from '@/data/employees';

interface RemoveEmployeeProps {
  employeeId: number;
  onClose: () => void;
}

export const RemoveEmployee = ({
  employeeId,
  onClose,
}: RemoveEmployeeProps) => {
  const { toast } = useNotification();
  const { mutate: removeEmployee, isPending } = useRemoveEmployee();

  const handleRemove = async () => {
    removeEmployee(
      { id: employeeId },
      {
        onSuccess: ({ data }) => {
          toast({
            content: data?.message || 'Usuário excluído com sucesso.',
            type: 'success',
          });
          onClose();
        },
        onError: (error) => {
          toast({
            content: error?.message || 'Erro ao excluir usuário.',
            type: 'error',
          });
        },
      }
    );
  };

  return (
    <BaseDialog
      onClose={onClose}
      fullWidth
      open
      title="Excluir usuário"
      actionsComponent={
        <>
          <Button onClick={onClose} variant="outlined">
            Cancelar
          </Button>
          <Button
            color="error"
            loading={isPending}
            onClick={handleRemove}
            variant="contained"
          >
            Excluir usuário
          </Button>
        </>
      }
    >
      <Stack spacing={1}>
        <Typography>Tem certeza que deseja excluir esse usuário?</Typography>
        <Typography>
          O acesso à plataforma será revogado imediatamente, mas matrículas
          feitas antes da exclusão continuam válidas.
        </Typography>
      </Stack>
    </BaseDialog>
  );
};
